
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#070808","d":"M7.5 1.196c3.476 0 6.304 2.828 6.304 6.304s-2.828 6.304-6.304 6.304S1.196 10.976 1.196 7.5 4.024 1.196 7.5 1.196m0-1.038a7.342 7.342 0 100 14.684A7.342 7.342 0 007.5.158z"}})])
          )
        }
      }
    